import { Env } from '..'

export const getApiUrl = (env: Env | undefined): string => {
  switch (env) {
    case 'test':
      return 'https://testaccountconsent.mediahuis.be/'
    case 'preview':
      return 'https://previewaccountconsent.mediahuis.be/'
    case 'production':
      return 'https://accountconsent.mediahuis.be/'
    default:
      return 'http://localhost:8080/'
  }
}

export const api = getApiUrl(MH_ENV)
export const apiPath = 'api/v1/'
